import { Link } from "react-router-dom";

export default function GdprConsent({ checked, onChange, testid = "gdpr-consent", className = "" }) {
  return (
    <label className={`flex items-start gap-3 cursor-pointer select-none ${className}`} data-testid={`${testid}-label`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={testid}
        className="mt-0.5 w-4 h-4 shrink-0 accent-[color:var(--gold,#d4af37)] cursor-pointer"
      />
      <span className="text-white/70 text-xs leading-relaxed">
        Súhlasím so spracovaním osobných údajov za účelom vybavenia môjho dopytu v zmysle{" "}
        <Link to="/ochrana-osobnych-udajov" target="_blank" className="text-gold hover:text-gold-light underline">
          zásad ochrany osobných údajov
        </Link>.
      </span>
    </label>
  );
}
